// TODO: maybe rename to OrderType
export default {
  SELL: 'sell',
  BUY: 'buy',
};
